import { clamp } from "./clamp";
import { normalize } from "./normalize";

export const normalizeClamped = (value: number, min: number, max: number): number =>
  clamp(normalize(value, min, max), 0, 1);
